import React from "react";
import classnames from "classnames";
import { ImagePopout } from "components/image-stream/image-popout";
import { EDITING_SOURCE_MAP, CODING_SHOT } from "../../photography/lib/helpers";

const sortByRowSortOrder = (a, b) => {
    return a.displayRowSortOrder - b.displayRowSortOrder;
};

const getRowClass = (row) => {
    switch (row) {
        case 1:
        case 2:
            return "-biggest";
        case 3:
        case 4:
        case 5:
            return "-bigger";
        default:
            return "";
    }
};

const ImageRow = (props) => {
    let rowClass = "";
    const shots = props.shots.map((shot, index) => {
        if (index === 0) {
            rowClass = getRowClass(shot.displayRow);
        }

        const rotate = shot.rotation ? shot.rotation : 0;
        const src = shot.editedImageUris && shot.editedImageUris.medium ? shot.editedImageUris.medium : "/images/noimage.jpg";
        const updatedOn = shot.updatedOn || "1";

        const imageClick = (e) => {
            e.preventDefault();

            if (props.imageClick) {
                props.imageClick(shot.key);
            }
        };

        return (
            <li
                key={shot.key}
                className={classnames({ "-premium": shot.isPremiumEditing })}
            >
                {props.isFinalQa && (
                    <div>
                        <div className={`image-holder`}>
                            <ImagePopout
                                photoKey={`shot_${shot.key}`}
                                imageUris={shot.editedImageUris}
                                shipmentKey={props.shipmentKey}
                                shipmentProductKey={props.shipmentProductKey}
                                alt={`Product ${shot.imageViewDescription || CODING_SHOT.imageViewDescription}`}
                                imageSize="medium"
                                isEdited
                                timeStamp={updatedOn}
                            />
                        </div>
                        <h5>
                            {`${shot.imageViewDescription || CODING_SHOT.imageViewDescription}`} <br />
                            <span>{shot.gs1MetadataShortDescription}</span>
                        </h5>
                    </div>
                )}
                {!props.isFinalQa && (
                    <a
                        href={`#shot_${shot.key}`}
                        onClick={imageClick}
                    >
                        <div className={`image-holder`}>
                            <img
                                alt={`Product ${shot.imageViewDescription || CODING_SHOT.imageViewDescription}`}
                                src={src + `?rotation=${rotate}&v=${updatedOn}`}
                            />
                        </div>
                        <h5>
                            {`${shot.imageViewDescription || CODING_SHOT.imageViewDescription}`} <br />
                            <span>{shot.gs1MetadataShortDescription}</span>
                        </h5>
                    </a>
                )}
            </li>
        );
    });

    return <ul className={rowClass}>{shots}</ul>;
};

const ImageList = (props) => {
    const rowsArr = [];
    const imageRows = props.shots
        .filter((shot) => (props.filterEmpty ? shot.editedImageUris !== null : shot))
        .reduce((obj, shot) => {
            if (shot.editingSourceId === EDITING_SOURCE_MAP["skipEditing"]) {
                return obj;
            }

            const row = shot.displayRow || "z";

            if (!rowsArr.includes(row)) {
                rowsArr.push(row);
                obj[row] = [];
            }

            obj[row].push(shot);

            return obj;
        }, {});

    rowsArr.sort();

    const rowHtml = rowsArr.map((r) => {
        imageRows[r].sort(sortByRowSortOrder);

        return (
            <ImageRow
                key={`row_${r}`}
                shots={imageRows[r]}
                imageClick={props.imageClick}
                isFinalQa={props.isFinalQa}
                shipmentKey={props.shipmentKey}
                shipmentProductKey={props.shipmentProductKey}
            />
        );
    });

    return <div className="ie-image-list">{rowHtml}</div>;
};

export default ImageList;
